import React, { useState, useEffect } from "react";
import { Box, Drawer, Button, Typography, Skeleton } from "@mui/material";
import * as S from "./styles";
import { Desafio } from "./desafio";
import { DesafioCard } from "./desafioCard";
import { returnEnvironment } from "../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/useAuthStore";
import { apiGetDesafios } from "../../services/apiGetDesafios";

const DesafiosList = ({ isWizard, onSelect, comunidadeId }) => {
    const [desafios, setDesafios] = useState([]);
    const [ isLoading, setIsLoading ] = useState(true);
    const creator = useAuthStore((state) => state.creator);

    useEffect(() => {
        const fetchDesafios = async () => {
            setIsLoading(true);
            try {
                if (comunidadeId) {
                    const response = await apiGetDesafios({ comunidade: comunidadeId });
                    setDesafios(response);
                } else {
                    const response = await apiGetDesafios();
                    setDesafios(response);
                } 
            } catch (error) {
                console.error("Erro ao buscar desafios:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchDesafios();
    }, [comunidadeId, creator?.id]);

    if (isLoading) {
        return (
            <Box sx={{ marginBottom: 3 }}>
                {Array.from({ length: 3 }).map((_, index) => (
                    <Skeleton
                        key={index}
                        variant="rectangular"
                        width="100%"
                        height={120}
                        sx={{
                            marginBottom: 2,
                            borderRadius: 2,
                            backgroundColor: "var(--grey-300-color)",
                        }}
                    />
                ))}
            </Box>
        );
    }

    return (
        <Box sx={{ marginBottom: 3 }}>
            {desafios?.length === 0 ? (
                <Typography variant="body2">Nenhum desafio encontrado.</Typography>
            ) : (
                desafios?.map((desafio, index) => {
                    return (
                        <Box key={index} sx={{ marginBottom: 3 }}>
                            <DesafioCard
                                desafio={desafio}
                                isWizard={isWizard}
                                onClick={() => onSelect(desafio)}
                                isFullWidth={true}
                            />
                        </Box>
                    );
                })
            )}
        </Box>
    );
};

export const Desafios = () => {
    const [selectedDesafio, setSelectedDesafio] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { state } = useLocation();
    const navigate = useNavigate();
    const isWizard = returnEnvironment() === "wizard";

    const handleOpenDesafio = (desafio) => {
        setSelectedDesafio(desafio);
        setDrawerOpen(true);
    };

    const handleCloseDesafio = () => {
        setDrawerOpen(false);
        setSelectedDesafio(null);
    };

    return (
        <>
            <S.Container>
                <S.Title variant="h5">Desafios</S.Title>
                <S.ScrollContainer isFullWidth={true}>
                    <DesafioCard
                        desafio={{
                            titulo: "Postar no feed",
                            pontos: 100,
                        }}
                        isWizard={isWizard}
                        onClick={() => navigate(`/novoPost/${state?.comunidade?.id}`, { state })}
                        isFullWidth={true}
                    />
                    <DesafiosList
                        isWizard={isWizard}
                        onSelect={handleOpenDesafio}
                        isFullWidth={true}
                        comunidadeId={state?.comunidade?.id}
                    />
                    <Box sx={{ width: "100%", marginTop: 3 }}>
                        <Button
                            onClick={() => window.history.back()}
                            variant="contained"
                            fullWidth
                            sx={{
                                backgroundColor: "var(--primary-color)",
                                color: "var(--white-color)",
                                padding: "10px 0",
                                "&:hover": {
                                    backgroundColor: "var(--primary-dark-color)",
                                },
                            }}
                        >
                            VOLTAR
                        </Button>
                    </Box>
                </S.ScrollContainer>
            </S.Container>

            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleCloseDesafio}
                sx={{
                    "& .MuiDrawer-paper": {
                        padding: 2,
                        width: "100%",
                        maxWidth: "600px",
                        height: "100%",
                        backgroundColor: "var(--white-color)",
                        overflowY: "auto",
                    },
                }}
            >
                {selectedDesafio && (
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <Desafio desafio={selectedDesafio} closeModal={handleCloseDesafio} />
                    </Box>
                )}
            </Drawer>
        </>
    );
};
